import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bcac-card',
  templateUrl: './bcac-card.component.html',
  styleUrls: ['./bcac-card.component.scss']
})
export class BcacCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  black = ''

}
